import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import BannerSlot from "./components/BannerSlot";
import Landing from "./pages/Landing";
import Explore from "./pages/Explore";
import PlaceDetail from "./pages/PlaceDetail";
import SubmitPlace from "./pages/SubmitPlace";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Moderation from "./pages/Moderation";
import Profile from "./pages/Profile";
import Topic from "./pages/Topic";

function AppShell() {
  const location = useLocation();

  // Handle Emergent Google Auth callback synchronously (session_id arrives in URL hash)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="App min-h-screen flex flex-col">
      <BannerSlot placement="header_top" />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/explorar" element={<Explore />} />
          <Route path="/lugar/:id" element={<PlaceDetail />} />
          <Route path="/cadastrar-lugar" element={<SubmitPlace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registrar" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/moderacao" element={<Moderation />} />
          <Route path="/perfil" element={<Profile />} />
          <Route path="/topico/:id" element={<Topic />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
